<script setup lang="ts">
import {Project, User} from "@/types";
import {ref} from "vue";
import {router} from "@inertiajs/vue3";

interface Props {
  project: Project
  user: User
}
const props = defineProps<Props>()

const isDialogOpen = ref(false)
const loading = ref(false)

const remove = () => {
    router.delete(route('projects.users.destroy', {project: props.project.slug, user: props.user.name}), {
        onStart: () => {
            loading.value = true;
        },
        onFinish: () => {
            loading.value = false;
        },
        onSuccess: () => {
            isDialogOpen.value = false
        }
    })
}
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        overlay-opacity="0.1"
    >
        <template #activator="{ props: attrs }">
            <default-btn
                v-bind="attrs"
                size="small"
                variant="text"
                rounded="lg"
                class="font-weight-medium text-error rounded border bg-grey-lighten-5"
            >
                Remove
            </default-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 bg-grey-lighten-4 border-b">
                Confirm you want to remove this collaborator
                <v-btn
                    variant="plain"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-5 black--text">
                <p class="mb-0 text-body-2">
                    Once removed, <b>{{ user.name }}</b> will no longer have access to <b>{{ project.name }}</b> project. However, their transfers will remain in the project.
                </p>
            </v-card-text>

            <v-card-actions class="px-5">
                <v-btn
                    variant="text"
                    size="small"
                    class="text-error text-none font-weight-medium text-body-2 bg-grey-lighten-4 border py-4 mb-2"
                    :block="true"
                    rounded="lg"
                    :loading="loading"
                    @click="remove"
                >
                    Remove {{ user.name }} from this repository
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
